module.exports = __webpack_public_path__ + "static/media/mental-health.594ddfa4.svg";